module.exports = __webpack_public_path__ + "static/media/world-map.9e909feb.svg";